import { IBaseIconProps } from "./IBaseIconProps";

// Line art drawn as filled shapes (PrimeIcons "gift", MIT), not strokes: the sidebar
// forces `fill` on every icon shape, which turned a stroked gift into a white blob.
export const GiftIcon = ({ color = "#ffffff" }: IBaseIconProps) => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19.5,7.75h-1.4c.4-.48,.65-1.08,.65-1.75,0-1.52-1.23-2.75-2.75-2.75-1.68,0-3.16,.89-4,2.21-.84-1.32-2.32-2.21-4-2.21-1.52,0-2.75,1.23-2.75,2.75,0,.67,.25,1.27,.65,1.75h-1.4c-.69,0-1.25,.56-1.25,1.25v2.5c0,.6,.43,1.08,1,1.2v6.8c0,.69,.56,1.25,1.25,1.25h13c.69,0,1.25-.56,1.25-1.25v-6.8c.57-.12,1-.6,1-1.2v-2.5c0-.69-.56-1.25-1.25-1.25Zm-.25,3.5h-6.5v-2h6.5v2Zm-3.25-6.5c.69,0,1.25,.56,1.25,1.25s-.56,1.25-1.25,1.25h-3.16c.34-1.43,1.63-2.5,3.16-2.5Zm-8,0c1.53,0,2.82,1.07,3.16,2.5h-3.16c-.69,0-1.25-.56-1.25-1.25s.56-1.25,1.25-1.25Zm-3.25,4.5h6.5v2H4.75v-2Zm1,3.5h5.5v6.5H5.75v-6.5Zm12.5,6.5h-5.5v-6.5h5.5v6.5Z" />
    </svg>
  );
};
